import React from 'react';
import { useSelector } from 'react-redux';
import { StoreBanner } from '@nykaa/ui-kit';
import styled from '@emotion/styled';
import { useTheme } from 'emotion-theming';
import { searchTypes } from 'constants/searchSuggestion';
import { SearchSuggestion } from 'types/searchSuggestion';
import SuggestionCard from './SuggestionCard';
import { State } from 'store/types';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { STORE_SUGGESTION } from 'constants/experiments';

interface SuggestionsProps {
  suggestions: SearchSuggestion[];
  handleClick: (suggestion: SearchSuggestion, position: number) => void;
  searchField?: string;
  searchSuggestionIcons: {};
}

interface WrapperProps {
  textColor: string;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  color: ${({ textColor }: WrapperProps) => textColor};
`;

function Suggestions({
  suggestions,
  handleClick,
  searchField = '',
  searchSuggestionIcons,
}: SuggestionsProps) {
  const theme: Theme = useTheme();
  const isStoreSuggestionEnabled = useSelector((state: State) =>
    getEligibleForVariant(state, STORE_SUGGESTION, 'A')
  );
  if (!suggestions || !(suggestions.length > 0)) {
    return null;
  }
  const visibleSuggestions = suggestions.filter((suggestion) => {
    const isSpecial = suggestion.type === searchTypes.SPECIAL_SUGGESTION;

    return isStoreSuggestionEnabled || !isSpecial;
  });

  const clickHandler = (suggestion: SearchSuggestion, position: number) => {
    // TODO: append params to URL
    handleClick(suggestion, position);
  };

  return (
    <Wrapper textColor={theme.darkGrey}>
      {visibleSuggestions?.map((suggestion, index) => {
        const { q, type } = suggestion;
        const isSpecialSuggestion = type === searchTypes.SPECIAL_SUGGESTION;

        if (isStoreSuggestionEnabled && isSpecialSuggestion) {
          return (
            <StoreBanner
              key={q}
              data={suggestion}
              onClick={() => clickHandler(suggestion, index + 1)}
            />
          );
        }
        return (
          <SuggestionCard
            key={q}
            handleClick={clickHandler}
            index={index + 1}
            searchField={searchField}
            suggestion={suggestion}
            searchSuggestionIcons={searchSuggestionIcons}
          />
        );
      })}
    </Wrapper>
  );
}

export default Suggestions;
